// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/store_payment.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { PaymentProcessorType } from "../../enum/v1/payment_processor_type_pb.js";
import { StorePaymentStatus } from "../../enum/v1/store_payment_status_pb.js";
import { StorePaymentPurpose } from "../../enum/v1/store_payment_purpose_pb.js";
import { StorePaymentType } from "../../enum/v1/store_payment_type_pb.js";

/**
 * @generated from message fingertip.common.type.v1.StorePayment
 */
export const StorePayment = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StorePayment",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "amount_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "application_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "stripe_charge_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "stripe_payment_intent_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "stripe_connected_account_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "payment_processor", kind: "enum", T: proto3.getEnumType(PaymentProcessorType) },
    { no: 10, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "error_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "error_message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "status", kind: "enum", T: proto3.getEnumType(StorePaymentStatus) },
    { no: 17, name: "test", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 18, name: "created_at", kind: "message", T: Timestamp },
    { no: 19, name: "updated_at", kind: "message", T: Timestamp },
    { no: 20, name: "purpose", kind: "enum", T: proto3.getEnumType(StorePaymentPurpose) },
    { no: 21, name: "particulars", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 22, name: "payment_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 23, name: "last4", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 24, name: "brand", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 25, name: "store_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "type", kind: "enum", T: proto3.getEnumType(StorePaymentType) },
    { no: 29, name: "original_payment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 30, name: "reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

